/**
 * Textos fiscales que ve el alumno en el checkout. Punto único: aquí y en
 * ningún otro sitio, para que cambiarlos no obligue a buscar literales por
 * media docena de componentes.
 *
 * El desglose se calcula con el tratamiento fiscal de la región, pero el texto
 * que ve el alumno es genérico: el nombre del impuesto solo aparece en la
 * factura.
 */
/**
 * Etiqueta de la línea de impuesto del desglose. Es la MISMA para todo el
 * mundo por decisión del owner (22/09/2026): el importe se recalcula según la
 * región, pero al alumno no se le dice si es IVA o IGIC, entre otras cosas
 * porque paga lo mismo en los dos casos. El nombre del impuesto sí aparece en
 * la factura.
 */
export const TAX_LINE_GENERIC_LABEL = 'Impuestos incluidos'

/** Etiqueta por línea de producto. Genérica siempre: se pinta ya en el paso 1. */
export const TAX_INCLUDED_ITEM_LABEL = '(impuestos incluidos)'

export const PROVINCE_LABEL = 'Provincia'
export const PROVINCE_PLACEHOLDER = 'Selecciona tu provincia'
export const PROVINCE_REQUIRED_ERROR = 'Selecciona tu provincia.'

/**
 * La provincia del paso 2 y la de la dirección de facturación tienen que ser
 * la misma: si no, el alumno vería un desglose y recibiría una factura con
 * otro impuesto (decisión D3, «nunca pueden convivir dos regiones»).
 */
export const provinceMismatchError = (
  declaredProvinceName: string,
  addressProvinceName: string
): string =>
  `La provincia de la dirección de facturación (${addressProvinceName}) no coincide con la que elegiste antes (${declaredProvinceName}). Corrige una de las dos para poder continuar.`

export const foreignAddressWithCanaryProvinceError = (
  declaredProvinceName: string
): string =>
  `Has indicado ${declaredProvinceName} como provincia, pero la dirección de facturación está fuera de España. Corrige una de las dos para poder continuar.`
